<template>
  <PageHeader :showBreadcrumb="true" />
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Create Quality Assurance Exam</h2>
        <Button size="lg" class="me-2" rounded raised label="Create an Exam" severity="primary" @click="router.push('/qualityAssurance/CreateExam')" />
      </div>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Quality Assurance File Uploads</h2>
        <Button size="lg" class="me-2" rounded raised label="Quality Assurance File Uploads" severity="primary" @click="router.push('/qualityAssurance/QualityAssuranceFileUploads')" />
      </div>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Reporting Phase</h2>
        <Button size="lg" class="me-2" rounded raised label="Reporting Phase" severity="primary" @click="router.push('/qualityAssurance/ReportingPhase')" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import PageHeader from "@/components/common/PageHeader.vue";
import Button from 'primevue/button';

const router = useRouter();
const userStore = useAuthStore();
</script>
<style scoped>
.portal-box {
  height: 200px;
}
.tx-col {
  height: 75%;
}
</style>

